import { DashboardNameAndEmojiInput } from '@modules/dashboard/components/DashboardNameAndEmojiInput';
import { DashboardHeader } from '@modules/dashboard/types';
import {
  DialogContent,
  DialogContentText,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

interface CreateNewDashboardDialogContentFormProps {
  dashboard: DashboardHeader;
  setDashboard: (dashboard: { name: string; emoji: string }) => void;
  analysisName: string;
}

export const CreateNewDashboardDialogContentForm = ({
  dashboard,
  setDashboard,
  analysisName,
}: CreateNewDashboardDialogContentFormProps) => {
  const [dialogRefInState, setDialogRefInState] =
    useState<HTMLDivElement | null>(null);

  const onNameChange = (name: string) => {
    setDashboard({ name, emoji: dashboard.emoji });
  };

  const onEmojiChange = (emoji: string) => {
    setDashboard({ name: dashboard.name, emoji: emoji });
  };

  return (
    <DialogContent ref={setDialogRefInState}>
      <DialogContentText>
        <Stack spacing={4}>
          <Typography variant="subtitle2" color="text.disabled">
            Create a Dashboard to save the "{analysisName}" Quantify to:
          </Typography>
          <DashboardNameAndEmojiInput
            emoji={dashboard.emoji}
            onEmojiChange={onEmojiChange}
            name={dashboard.name}
            onNameChange={onNameChange}
            dialogRef={dialogRefInState}
          />
        </Stack>
      </DialogContentText>
    </DialogContent>
  );
};
